// extracted by mini-css-extract-plugin
export default {"infoCard":"BindStationModal_infoCard__2nSaY","dividerStyle":"BindStationModal_dividerStyle__5cq5N"};